import useSWR from "swr";
import API from "../../../axios/instances/API";

const fetcher = async (url) => {
  const { data } = await API.get(url);
  return data;
};

const useAudienceOptions = () => {
  const { data, error, mutate } = useSWR(
    "/dashboard/audiences/options/",
    fetcher,
    {
      revalidateOnFocus: false,
      revalidateOnReconnect: false,
    },
  );

  return {
    options: data,
    isLoading: !error && !data,
    isError: error,
    mutate,
  };
};

export default useAudienceOptions;
